import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
import { de } from 'date-fns/locale';
import { debounceTime, distinct, distinctUntilChanged } from 'rxjs/operators';
import { O } from '@angular/cdk/overlay-module.d-B3qEQtts';
export interface Section {
  hdID: string;
  MainDescr: string;
}
export interface FilterValue {
  filter: string;
  GenID: string;
}
@Component({
    selector: 'app-general-master',
    templateUrl: './general-master.component.html',
    styleUrls: ['./general-master.component.css'],
    standalone: false
})
export class GeneralMasterComponent implements OnInit {
  FormSearchGenMaster: FormGroup;
  masters: any;
  master: any;
  url: string;
  modalURL: string;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  HideMasterDetails: string;
  id: any;
  ModalName: string;
  pageurl: string;
  RightsID: string;
  MsgType: any;
  DisplayMessage: string;
  ManageMasterName: string;
  pageNumber: number;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  filteredData: any[];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
isLoading: any = false;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }
  ngOnInit() {
    this.pageNumber = 1;
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202042001') || this.RightsID.includes('202042021') || this.RightsID.includes('202042000')) {
    } else {
      window.location.href = "module/0";
    }
    this.HideMasterDetails = '!isHidden';
    this.getAll();
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    this.getMaster(this.id, '');
    this.FormSearchGenMaster = this.formBuilder.group({
      txtSearch: ['']
    });
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
    this.FormSearchGenMaster.get('txtSearch').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.filteredTable(value);
    })
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filteredTable('')
  }
  onSearchGenMaster(SearchData) {
    this.FetchGen(this.id, SearchData.txtSearch);
  }

  FetchGen(genid, filter) {
    let filterValue: FilterValue = {
      filter: filter,
      GenID: genid,
    };
    this.http.post(this.url + 'GM/SearchGenMaster', filterValue)
      .subscribe((data) => {
        if (data == null) {
          this.MsgType = 0;
          this.master = null;
        } else {
          this.MsgType = 1;
          this.master = JSON.parse(data.toString());
          this.modalURL = '';
          // this.ManageMasterName = data.GenGenDescr;
        }
      }
      );
  }
  OpenModal(url, modelName, no) {
    this.modalURL = url + '/' + this.id + '/' + no;
    if (this.ManageMasterName == "") { this.ManageMasterName = "Add General Master"; }
    this.ModelFor = "Add " + modelName + " Master";
    // this.ModelFor = "Add "+this.ManageMasterName+ " Master";
  }
  OpenModal1(url, modelName, no) {
    this.modalURL = url + '/' + this.id + '/' + no;

    this.ModelFor = "Update " + modelName + " Master";
  }

  getAll() {
    this.http.get(this.url + 'GM/GetAll')
      .subscribe((data) => {
        if (data == null) {
          data = 'No Data Found';
        }
        this.masters = JSON.parse(data.toString());
        this.ManageMasterName = this.masters.find(x => x.GenID == this.id).GenDescr;
      }
      );
  }
  disablefunction(mDtl) {
    let confirmationText = `Are you sure to ${mDtl.Status} it ?`;
    this.alertService.showConfirm(confirmationText).then((result) => {
      if (result) {
        this.http.get(this.url + 'GM/updateGenMasterStatus?GenID=' + mDtl.ID)
          .subscribe((data) => {
            if (data == null) {
              this.alertService.showError('Check Your Internet Connection');
            } else {
              this.alertService.showSuccess('Successfully Updated Status');
              this.getMaster(this.id, '');
            }
          }
          );
      }
    });
  }

  deleteGenMaster(StatusID) {
    this.alertService.showConfirm('Are you sure to delete it ?').then((result) => {
      if (result) {
        this.http.get(this.url + 'GM/deleteGenMaster?GenID=' + StatusID)
          .subscribe((data) => {
            if (data == null) {
              this.alertService.showError('You can not delete this record');
            } else {
              this.alertService.showSuccess('Master deleted Successfully');
              this.getMaster(this.id, '');
            }
          }
          );
      }
    })
    //   if (confirm('Are you sure to delete it ?')) {
    //   this.http.get(this.url + 'GM/deleteGenMaster?GenID=' + StatusID)
    // .subscribe( (data) =>   {
    //     if (data == null) {
    //       this.alertService.showError('You can not delete this record');
    //     } else {
    //       this.alertService.showSuccess('Master deleted Successfully');
    //       this.getMaster(this.id, '');
    //     }
    //   }
    // );
    // }
  }

  getMaster(GenID: string, masterName: string) {
    this.ManageMasterName = masterName;
    this.HideMasterDetails = '';
    this.id = GenID;
    this.isLoading = true;
    this.http.get(this.url + 'GM/GetMasterDetail?GenID=' + GenID)
      .subscribe((data) => {
        this.isLoading = false;
        if (data == null) {
          this.MsgType = 0;
          this.master = null;
          this.filteredData = [];
        } else {
          this.MsgType = 1;
          this.master = JSON.parse(data.toString());
          this.filteredTable('');
          this.onPageSizeChange(10);
          this.totalRecords = this.master.length;
          this.pageNumber = 1;
          this.modalURL = '';
          // this.ManageMasterName = data.GenGenDescr;
        }
      },(error) => {
        this.isLoading = false;
        this.MsgType = 0;
        this.master = null;
        this.filteredData = [];
      });
  }
  onDelete() {
    this.alertService.showWarning('You Have No Right To Delete.');
  }
  filteredTable(searchText: string) {
    if(!searchText){
      this.filteredData = [...this.master];
      return;
    }
    this.filteredData = this.master.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
}
